 import React from 'react';
  import PropTypes from 'prop-types';

  const Widget = ({ icon, title, value, type }) => {
    const typeColors = {
      info: { border: 'border-info', text: 'text-info' },
      success: { border: 'border-success', text: 'text-success' },
      warning: { border: 'border-warning', text: 'text-warning' },
      danger: { border: 'border-danger', text: 'text-danger' },
      setpar: { border: 'border-primary', text: 'text-primary' },
    };

    const colors = typeColors[type] || typeColors.info;

    return (
      <div
        className={`d-flex align-items-center p-3 bg-white rounded shadow-sm mb-3 border-left border-4
  ${colors.border}`}
        style={{ borderLeftWidth: '4px' }}
      >
        <div className={`mr-3 ${colors.text}`} style={{ fontSize: '2.5rem', opacity: 0.9 }}>
          <i className={`fa ${icon}`} />
        </div>
        <div className="d-flex flex-column">
          <span className="font-weight-bold text-dark" style={{ fontSize: '2rem', lineHeight: 1 }}>
            {value}
          </span>
          <span className="text-muted" style={{ fontSize: '0.9rem', marginTop: '5px' }}>
            {title}
          </span>
        </div>
      </div>
    );
  };

  Widget.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    type: PropTypes.oneOf(['info', 'success', 'warning', 'danger', 'setpar']),
  };

  Widget.defaultProps = {
    type: 'info',
  };

  export default Widget;